/*
 * This code is the intellectual property of Bulb Inc. and other software publishers.
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Component, Input } from '@angular/core';

@Component({
  selector: 'bulb-tiles-footer-icon',
  templateUrl: './tiles-footer-icon.component.html',
  styleUrls: ['./tiles-footer-icon.component.scss'],
  standalone: false,
})
/**
 * This component is a generic icon component used to display single icons or
 * icons with text. This is used in the tiles-footer component
 */
export class TilesFooterIconComponent {
  /**
   * Input to determine when the icon is visible or not
   */
  @Input() visibility?: boolean = true;

  /**
   * Input for the icon key used in the svg-icon component
   */
  @Input() iconKey: string;

  /**
   * Whether or not to display the default color (grey) or red
   */
  @Input() alert?: boolean = false;

  /**
   * Text to be displayed in the icon with text part of this component
   */
  @Input() label?: string;

  /**
   * Tooltip translation key to be displayed in the title attribute
   */
  @Input() tooltip?: string;
}
